import React from "react";
import Particles from "react-particles"; // ✅ fixed import
import { loadBasic } from "@tsparticles/basic";
import styles from './Particles.module.css';

const ParticlesBg = ({ id, className }) => {
  const particlesInit = async (engine) => {
    await loadBasic(engine);
  };

  return (
    <div id={id} className={`${styles.particlesContainer} ${className}`}>
      <Particles
        id={`${id}-particles`}
        init={particlesInit}
        options={{
          background: {
            color: {
              value: "transparent",
            },
          },
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                area: 800,
              },
            },
            color: {
              value: "#ffffff",
            },
            shape: {
              type: "circle",
            },
            opacity: {
              value: 0.5,
            },
            size: {
              value: 3,
              random: true,
            },
            links: {
              color: "#ffffff",
              distance: 150,
              enable: true,
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 2,
              direction: "none",
              random: false,
              straight: false,
              outModes: {
                default: "out",
              },
            },
          },
          interactivity: {
            events: {
              onHover: {
                enable: true,
                mode: "repulse",
              },
              onClick: {
                enable: true,
                mode: "push",
              },
            },
            modes: {
              repulse: {
                distance: 100,
                duration: 0.4,
              },
              push: {
                quantity: 4,
              },
            },
          },
        }}
      />
    </div>
  );
};

export default ParticlesBg;
